var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"landing"}},[_c('SectionTitle',{attrs:{"showApply":""}}),_c('SectionWhy'),_c('SectionBenefit'),_c('SectionProcess'),_c('SectionFee',{attrs:{"showApply":""}}),_c('SectionReview'),_c('SectionMoney',{attrs:{"showApply":""}}),_c('SectionFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }